// Single source of truth for the 2-instalment payment plan.
// The plan adds a fixed £100 fee on top of the course price, split across 2 payments.
export const INSTALMENT_PLAN_FEE = 100;
export const INSTALMENT_COUNT = 2;

export function getInstalmentPlan(course) {
  if (!course || !course.installmentEnabled || !(Number(course.price) > 0)) return null;
  const perInstalment = Math.round((Number(course.price) + INSTALMENT_PLAN_FEE) / INSTALMENT_COUNT);
  return {
    count: INSTALMENT_COUNT,
    perInstalment,
    total: perInstalment * INSTALMENT_COUNT,
    planFee: INSTALMENT_PLAN_FEE,
  };
}
